import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../services/api";

import {
	IconDashboard,
	IconWhatsApp,
	IconContacts,
	IconQuickAnswers,
	IconBulkMessaging,
	IconSchedule,
	IconGoogleAgenda,
	IconTags,
	IconSalesFunnel,
	IconSocialComments,
	IconDocumentation,
} from "./SidebarIcons";

import { i18n } from "../translate/i18n";
import { AuthContext } from "../context/Auth/AuthContext";
import { isMasterUser } from "../helpers/masterUser";

function ListItemLink({ to, primary, icon: Icon, onClick, selected }) {
	const location = useLocation();
	const isSelected =
		selected ??
		(location.pathname === to || (to !== "/" && location.pathname.startsWith(to)));

	return (
		<li className={`menu-item${isSelected ? " active" : ""}`}>
			<Link
				to={to}
				onClick={onClick}
				title={primary}
				className={`menu-link${isSelected ? " active" : ""}`}
			>
				<span className="menu-icon">{Icon && <Icon />}</span>
				<span className="menu-text">{primary}</span>
			</Link>
		</li>
	);
}

function MainListItems({ drawerClose }) {
	const { user } = useContext(AuthContext);
	const location = useLocation();
	const [hasSaleFunnel, setHasSaleFunnel] = useState(false);

	useEffect(() => {
		const checkSalesFunnelLink = async () => {
			try {
				const { data } = await api.get("/sales-funnel/user");
				setHasSaleFunnel(Array.isArray(data) && data.length > 0);
			} catch (error) {
				console.log("Erro ao verificar funil de vendas:", error);
				setHasSaleFunnel(false);
			}
		};

		checkSalesFunnelLink();
	}, []);

	if (isMasterUser(user)) {
		return null;
	}

	return (
		<ul className="side-nav p-3" onClick={drawerClose}>
			<li className="menu-title">Overview</li>
			<ListItemLink
				to="/"
				selected={location.pathname === "/"}
				primary="Dashboard"
				icon={IconDashboard}
			/>

			<li className="menu-title">Apps</li>
			<ListItemLink
				onClick={() => localStorage.setItem("administracao", JSON.stringify(true))}
				to="/tickets"
				selected={location.pathname.startsWith("/tickets")}
				primary={i18n.t("mainDrawer.listItems.tickets")}
				icon={IconWhatsApp}
			/>
			<ListItemLink
				to="/social-comments"
				selected={location.pathname.startsWith("/social-comments")}
				primary={i18n.t("mainDrawer.listItems.socialComments")}
				icon={IconSocialComments}
			/>
			<ListItemLink
				to="/schedules"
				selected={location.pathname === "/schedules"}
				primary={i18n.t("mainDrawer.listItems.schedules")}
				icon={IconSchedule}
			/>
			<ListItemLink
				to="/google-agenda"
				selected={location.pathname === "/google-agenda"}
				primary={i18n.t("mainDrawer.listItems.googleAgenda")}
				icon={IconGoogleAgenda}
			/>
			<ListItemLink
				to="/contacts"
				primary={i18n.t("mainDrawer.listItems.contacts")}
				selected={location.pathname === "/contacts"}
				icon={IconContacts}
			/>
			<ListItemLink
				to="/quickAnswers"
				selected={location.pathname === "/quickAnswers"}
				primary={i18n.t("mainDrawer.listItems.quickAnswers")}
				icon={IconQuickAnswers}
			/>
			<ListItemLink
				to="/documentacao"
				selected={location.pathname.startsWith("/documentacao")}
				primary={i18n.t("mainDrawer.listItems.documentation")}
				icon={IconDocumentation}
			/>
			<ListItemLink
				to="/bulk-messaging"
				selected={location.pathname === "/bulk-messaging" || location.pathname.startsWith("/bulk-messaging/")}
				primary="Envio em massa"
				icon={IconBulkMessaging}
			/>
			<ListItemLink
				to="/tags"
				selected={location.pathname === "/tags"}
				primary={i18n.t("mainDrawer.listItems.tags")}
				icon={IconTags}
			/>
			{(user.profile === "admin" || hasSaleFunnel) && (
				<ListItemLink
					to="/sales-funnel"
					selected={location.pathname === "/sales-funnel"}
					primary={i18n.t("mainDrawer.listItems.salesFunnel")}
					icon={IconSalesFunnel}
				/>
			)}
		</ul>
	);
}

export default MainListItems;
